// extracted by mini-css-extract-plugin
module.exports = {"hero":"invitation-main_hero__xn0Q8"};